<template>
    <div>
        <div v-if="isShow" class="modal d-block" id="Modal1" tabindex="-1" aria-labelledby="Modal1Label" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered custom-modal">
                <div class="modal-content">
                    <div class="modal-bg">
                        <p class="text-select">Availability</p>
                            <div v-if="selectedAvailability && selectedAvailability.length">
                                <div v-for="(eachAvailability, index) in selectedAvailability" :key="index">
                                    <div  class="type-boat">
                                        <p class="title-text">{{eachAvailability.boat_name}}</p>
                                        <p class="status-text" :style="`color: ${eachAvailability.status_color}`">{{eachAvailability.status}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="text-no-available" v-else>There is no available boat.</div>
                    </div>
                    <button class="button-close" @click="closeModal">Close</button>
                </div>
            </div>
        </div>

        <div v-if="isShow" class="custom-modal-backdrop fade" :class="{show: isShow}"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isShow: false,
            selectedAvailability: []
        }
    },
    methods: {
        showModal (selectedAvailability) {
            this.isShow = true
            this.selectedAvailability = selectedAvailability
        },
        closeModal () {
            this.isShow = false
        }
    }
}
</script>

<style lang="scss" scoped>
    .custom-modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 1040;
        width: 100vw;
        height: 100vh;
        background-color: #000;
    }

    .custom-modal-backdrop.hide {
        opacity: 0;
    }

    .custom-modal-backdrop.show {
        opacity: 0.6;
    }
    .custom-modal {
        max-width: 30% !important;
    }
    .modal-content {
        height: 60vh;
        border: 2px solid #405669;
    }
    .text-select {
        color: #163856;
        font-family: 'Trocchi';
        font-weight: bold;
        font-size: 30px;
        text-align: center;
        padding-top: 10px;
    }
    .type-boat {
        padding-top: 10px;
        display: flex;
    }
    .title-text {
        color: #163856;
        font-family: 'Trocchi';
        font-weight: bold;
        font-size: 20px;
        width: 60%;
        padding-left: 20px;
    }
    .status-text {
        font-family: 'Trocchi';
        font-weight: bold;
        font-size: 20px;
        width: 40%;
        padding-left: 20px;
    }
    .button-close {
        margin: auto;
        margin-bottom: 30px;
        background: #163856;
        color: #fff;
        width: 100px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        border: none;
        -moz-user-select: none;
        -khtml-user-select: none;
        -webkit-user-select: none;
    }
    .text-no-available {
        padding: 20px;
        font-size: 20px;
        font-family: 'Trocchi';
    }
    // responsive for mobile
    @media only screen and (max-width: 600px) {
        .custom-modal {
            max-width: 100% !important;
        }
    }
</style>